module.exports = __webpack_public_path__ + "img/Master.87cb71b1.svg";